//人员相关接口 与甲方提供一致
// http://39.104.163.194:8385/WHHG/  万辉  wh  123456
// http://39.104.102.42:8382/JSXDZ/ xdz  123456
// http://39.104.28.125:8084/JSLLGFZ/  兰陵  lanling   123456
import $ajax from 'axios'
import qs from 'qs';
import D3Config from '@/utils/D3Config'
const base_url=D3Config.base_url
// const base_url = '/api/WHHG'
// const base_url = '/v1'
export function getAllHisWorker(username,password) {
    return $ajax({
        url: base_url+'/open/information/getHardPage.do?',
        method: "GET",
        params:{
            username:username,
            password:password,
            page:1,
            rows:1000
        }
    })
}
//获取所有员工信息
export function getAllWorker(username, password) {
  return $ajax({
    url: base_url + '/open/information/getRealGps.do?',
    method: "GET",
    params: {
      username: username,
      password: password
    }
  })
}

//获取所有员工信息
export function findEmpByEquipmentNo(params) {
  return $ajax({
    url: '/v1/employee/findEmpByEquipmentNo',
    method: "POST",
    data:params
  })
}

//获取历史轨迹信息
export function getHistory(username,password,begintime, endtime, deveuis) {
  return $ajax({
    url:base_url+'/open/information/getHis.do?',
    method: "GET",
    params: {
      username: username,
      password: password,
      begintime: begintime,
      endtime: endtime,
      deveuis: deveuis
    }
  })
}
//获取所有员工信息
export function getWarn(username, password, type) {
  return $ajax({
    url: base_url + '/warn/getRealAreaWarn.do?',
    method: "GET",
    params: {
      username: username,
      password: password,
      warnType: type
    },
  })
}
//获取柱状图信息
export function getPeople(username, password) {
  return $ajax({
    url: base_url + '/ajpt/getRealAreaInfo.do',
    method: "GET",
    params: {
      username: username,
      password: password
    },
  })
}
//获取所有报警数据
export function getPolice(username, password,wranType,warnTime) {
  return $ajax({
    url: base_url + '/warn/getWarnByType.do',
    method: "GET",
    params: {
      username: username,
      password: password,
      type: wranType,
      warnTime:warnTime*24*60*60
    },
  })
}
//提交处理参数
export function getConfirmOpinion(username, password,confirmOpinion) {
  return $ajax({
    url: base_url + '/warn/getWarnConfirmMsg.do',
    method: "GET",
    params: {
      username: username,
      password: password,
      confirmOpinion: confirmOpinion
    },
  })
}
//获取二道门数据
export function getFindSirenTimelyData() {
  return $ajax({
    url: '/v1/attendanceRecord/empNumber',
    method: "GET"
  })
}
//获取作业票
export function getWork(curPage,limit) {
  return $ajax({
    url: '/v1/workPermit/getWork',
    method: "GET",
    params: {
      curPage: curPage,
      limit: limit
    },
  })
}

//修改监控
export function updateLagLat(params) {
  return $ajax({
    url: '/v1/fluorite_camera/updateLagLat',
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:qs.stringify(params)
  })
}
//获取监控
export function getCameraList(curPage,limit) {
  return $ajax({
    url: '/v1/fluorite_camera/list',
    method: "POST",
    params: {
      curPage: curPage,
      limit: limit
    },
  })
}
let token = localStorage.getItem("token");
//获取人员详情
export function getMacByEmp(deviceno) {
  return $ajax({
    url: '/v1/employee/getByPosNum',
    method: "get",
    headers: {
      'token': token
    },
    params: {
      number: deviceno
    }
  })
}
//获取人员考试记录
export function getExamrecord(deviceno) {
  return $ajax({
    url: '/v1/examrecord/getByPosNum',
    method: "get",
    headers: {
      'token': token
    },
    params: {
      number: deviceno,
      // curPage:1,
      // limit:10
    }
  })
}
//获取个人证书列表
export function getCertificate(deviceno) {
  return $ajax({
    url: '/v1/certificate/getByPosNum',
    method: "get",
    headers: {
      'token': token
    },
    params: {
      number: deviceno,
      curPage:1,
      limit:10
    }
  })
}
//获取培训记录
export function getCultivate(deviceno) {
  return $ajax({
    url: '/v1/cultivate/getByPosNum',
    method: "get",
    headers: {
      'token': token
    },
    params: {
      number: deviceno,
      // curPage:1,
      // limit:10
    }
  })
}
